import React from 'react';
import DualDeckPlayer from '../DualDeckPlayer';
import { formatModeLabel } from '../../utils/formatters';

const CenterDeckSection = ({
  activePart,
  playedTracksCount,
  playedTracksTotalDuration,
  formatDuration,
  // DualDeckPlayer props
  decksInfo,
  currentTrack,
  nextTrack,
  deckATrack,
  deckBTrack,
  onPlayPause,
  onNext,
  onVolumeChange,
  onDeckVolumeChange,
  onCrossfaderChange,
  onSettingsChange,
  onPitchChange,
  onSeek,
  onCue,
  onLoop,
  onSync,
  onDeckDrop,
  playerSettings,
  volume,
  playbackInfo,
  pitchInfoA,
  pitchInfoB,
  loopSizeA,
  loopSizeB,
  onLoopChange,
  loopRollSizeA,
  loopRollSizeB,
  onLoopRollStart,
  onLoopRollEnd
}) => {
  return (
    <div className="flex-1 flex flex-col space-y-2">
      {/* Current Part Info */}
      <section 
        className="bg-dark-card/80 backdrop-blur-xl border border-sunset-orange/30 rounded-2xl p-4 sm:p-6"
        role="region"
        aria-label="Partie actuellement active"
      >
        <div className="flex items-center justify-between mb-3 md:mb-4">
          <h2 className="text-base sm:text-lg font-semibold text-text-primary">Partie actuelle</h2>
          <span 
            className="px-2 sm:px-3 py-1 rounded-full text-xs font-medium bg-purple-500/20 text-sunset-orange border border-sunset-orange/30"
            aria-label={`Mode: ${activePart?.mode ? formatModeLabel(activePart.mode) : 'Aucune'}`}
          >
            {activePart?.mode ? formatModeLabel(activePart.mode) : 'Aucune'}
          </span>
        </div>
        <div 
          className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 truncate" 
          data-testid="current-part-name"
          title={activePart?.name || 'Sélectionnez une partie'}
        >
          {activePart?.name || 'Sélectionnez une partie'}
        </div>
        
        {/* Durée totale jouée */}
        {playedTracksCount > 0 && (
          <div className="flex items-center gap-2 text-sm">
            <span className="text-sunset-orange/60">Durée jouée:</span>
            <span className="px-2 py-1 rounded-full bg-purple-500/20 text-sunset-orange font-mono">
              {formatDuration(playedTracksTotalDuration)}
            </span>
            <span className="text-sunset-orange/40">
              ({playedTracksCount} titre{playedTracksCount > 1 ? 's' : ''})
            </span>
          </div>
        )}
      </section>

      {/* Dual Deck Player */}
      <DualDeckPlayer
        decksInfo={decksInfo}
        currentTrack={currentTrack}
        nextTrack={nextTrack}
        deckATrack={deckATrack}
        deckBTrack={deckBTrack}
        onPlayPause={onPlayPause}
        onNext={onNext}
        onVolumeChange={onVolumeChange}
        onDeckVolumeChange={onDeckVolumeChange}
        onCrossfaderChange={onCrossfaderChange}
        onSettingsChange={onSettingsChange}
        onPitchChange={onPitchChange}
        onSeek={onSeek}
        onCue={onCue}
        onLoop={onLoop}
        onSync={onSync}
        onDeckDrop={onDeckDrop}
        playerSettings={playerSettings}
        volume={volume}
        playbackInfo={playbackInfo}
        pitchInfoA={pitchInfoA}
        pitchInfoB={pitchInfoB}
        currentMode={activePart?.mode}
        loopSizeA={loopSizeA}
        loopSizeB={loopSizeB}
        onLoopChange={onLoopChange}
        loopRollSizeA={loopRollSizeA}
        loopRollSizeB={loopRollSizeB}
        onLoopRollStart={onLoopRollStart}
        onLoopRollEnd={onLoopRollEnd}
      />
    </div>
  );
};

export default CenterDeckSection;
